import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'zodiac-libra', 'ZodiacLibra', [["path",{"d":"M5 20l14 0"}],["path",{"d":"M5 17h5v-.3a7 7 0 1 1 4 0v.3h5"}]]);